import { useHeader } from '../../../hooks';
import { Header as CommonHeader } from '@vfpt/common-fe-components';
import {
    mapHeaderToControlButtons,
    mapHeaderToLargeMenuLeft,
    mapHeaderToLargeMenuRight,
    mapHeaderToMenuItems
} from '../headerAdapter';
import { HeaderProps } from '../Header.types';

const VodafoneHeader = ({ login }: Pick<HeaderProps, 'login'>) => {
    const { headerData, loading } = useHeader({ name: 'Header_assembly_pt' });

    if (loading || !headerData) {
        return null;
    }

    return (
        <CommonHeader
            menuItems={mapHeaderToMenuItems(headerData)}
            largeMenuItemsLeft={mapHeaderToLargeMenuLeft(headerData)}
            largeMenuItemsRight={mapHeaderToLargeMenuRight(headerData)}
            controlButtonsProps={mapHeaderToControlButtons(headerData, login)}
            enableHover={false}
            logoHref={window.location.pathname}
            menuLabel="Menu" //TODO: add i18n key
            closeLabel="Fechar" //TODO: add i18n key
        />
    );
};

export default VodafoneHeader;
